import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" style={styles.footer}>
      <p className="copyright" style={styles.text}>
        &copy; Untitled. Design: <a href="https://github.com/antonio0204" style={styles.link}>Ronal Aguirre</a>.
      </p>
    </footer>
  );
}

const styles = {
  footer: {
    // backgroundColor: '#333',
    // padding: '20px',
    textAlign: 'center' as const, // Añadimos 'as const' para indicar un tipo constante
    color: '#fff',
    position: 'fixed' as const, // Añadimos 'as const' para indicar un tipo constante
    bottom: '0',
    left: '0',
    width: '100%',
  },
  text: {
    margin: '0',
    fontSize: '14px',
  },
  link: {
    color: '#fff',
  },
};

export default Footer;
